// extracted by mini-css-extract-plugin
export var headerText = "home-module--header-text--_5-2Y";
export var logo = "home-module--logo--1CZDj";
export var carouselSection = "home-module--carousel-section--2phfJ";